import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import ListPosts from '../Utils/ListPosts'
import { useDispatch, useSelector } from 'react-redux'
import { getActiveToken, getToken } from '../../RTK/Slice/Auth/AuthSlice'
import { notEmpty } from '../../Validation'
import { toast } from 'react-toastify'
import { getSpcifcPostData, getSpecificPostAPI } from '../../RTK/Slice/SpecificPost/SpecificPostSlice'
import ListPostsNormal from '../Utils/ListPostNormal'
import { useTranslation } from 'react-i18next'

const SpecificPostWithId = () => {

    // For Translation
    const {t} = useTranslation(); 

    // For Access Search Input
    const [postId , setPostId] = useState('') ; 

    // For Dispatch Action
    const dispatch = useDispatch() ; 

    // For Get Token
    const token = useSelector(getToken) ; 

    // For Get Active Token
    const userToken = useSelector(getActiveToken) ; 

    // For Search Grpup Handler
    const searchGroupHandler = (e)=>{
        e.preventDefault() ; 
        if(notEmpty(postId)){
            dispatch(getSpecificPostAPI({token , postId  , userToken }))
        }else{
            toast.info("please Enter Post ID")
        }
    }

    // For Access Post Data
    const {post , status} = useSelector(getSpcifcPostData);




    
  return (
    <div className='search-group-id-section'>

        <form className='search-group' onSubmit={searchGroupHandler}>
            <div className='search-field'>
                <FontAwesomeIcon onClick={searchGroupHandler} icon={faMagnifyingGlass} />
                <input style={{marginInlineStart :"8px"}} autoFocus onChange={(e)=>setPostId(e.target.value)} placeholder={t('extractPost')}/>
            </div>
            <button type="submit" className='get-group-btn'>{t('extract')} </button>
        </form>

        <div className='all-posts'>
            <ListPostsNormal  hideSearch={true} hideAddPost={true} showNonZero={false} selectAllOption={false}  posts={post.id === undefined ? "":  Object.assign([] , [post])} status={status} />
        </div>
        
    </div>
  )
}

export default SpecificPostWithId
